import { t, i18n } from '@/helpers/i18n';
import { save } from '@/helpers/storage';
import { momentTZ as moment } from '@/helpers/moment';
import { event } from 'vue-analytics';
const mutations = {
    setState(state, val) {
        if (typeof val == 'object' && val.val) {
            state.state = t(val.val) + (val.err ? ' ' + val.err : '');
        }
        else {
            state.state = String(t(val));
        }
    },
    clearState(state) {
        state.state = '';
    },
    setLastErr(state, err) {
        state.lastErr = err;
        event('root-store', 'commit-setLastErr', err);
    },
    setTZName(state, payload) {
        state.timezone = payload;
        event('root-store', 'commit-setTZName', payload);
    },
    setLang(state, payload) {
        save('lang', payload);
        i18n.locale = payload;
        moment.locale(payload == "en" ? "us" : payload);
        event('root-store', 'commit-setLang', payload);
    }
};
export default mutations;
